import {Points, Reward, Item as RewardItem, Points as RewardWallet, ContestReward} from "@jnext/ts-axios-contestformat"
import { JBadgeListProps } from "../../JBadgeList"

export type AmbiguousReward = RewardItem | RewardWallet

export function isRewardItem(ambiguousReward: any): ambiguousReward is RewardItem {
    return ambiguousReward?.product
}
export function isRewardWallet(ambiguousReward: any): ambiguousReward is RewardWallet {
    return ambiguousReward?.walletCms
}

export function toFlatAmbiguousContestRewards(rewards: ContestReward[]) {
    const arr: AmbiguousReward[] = []
    for (const reward of rewards) {
        if (reward.rewardItems) {
            for (const rewardItem of reward.rewardItems) {
                arr.push(rewardItem)
            }
        }
        if (reward.rewardWallets) {
            for (const rewardWallet of reward.rewardWallets) {
                arr.push(rewardWallet)
            }
        }
    }
    return arr
}

export function pointsToJBadgeItem(contestCosts: Points[] = []): JBadgeListProps['items'] {
    return contestCosts.map(c => ({
        value: c.amount,
        title: c.walletCms?.title,
        text: c.walletCms?.text,
        imageRef: c.walletCms?.imageRef
    }))
}
export function rewardsToJBadgeItem(rewards: Reward[] = []): JBadgeListProps['items'] {
    return pointsToJBadgeItem(
        toFlatAmbiguousContestRewards(rewards).filter(isRewardWallet)
    )
}